import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';

const sxRoot = { width: '100%', maxWidth: 800 };

export default function OneIngredient(prop) {
  const [checked, setChecked] = React.useState([0]);
  const value = 1
  const labelId = `checkbox-list-primary-label-${value}`;

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <List dense sx={sxRoot}>
          <ListItem  key={value} button>
            <ListItemAvatar>
              <Avatar
                alt={`Black...`}
                src={prop.image}
              />
            </ListItemAvatar>
            <p id={labelId} secondary  > <b>{prop.description}</b></p>
            <ListItemSecondaryAction>
              <Checkbox
                edge="end"
                onChange={handleToggle(value)}
                checked={checked.indexOf(value) !== -1}
                inputProps={{ 'aria-labelledby': labelId }}
              />
            </ListItemSecondaryAction>
          </ListItem>
    </List>
  );
}
